import { z } from "zod";

// 116 -- record a ball: runs (0-6) or a wicket.
export const recordCricketEventSchema = z
  .object({
    kind: z.enum(["runs", "wicket"]),
    runs: z.number().int().min(0).max(6).optional(),
  })
  .refine((d) => d.kind === "wicket" || d.runs != null, {
    message: "runs is required when kind is 'runs'",
    path: ["runs"],
  });

// Parsed from the GET query string, so numbers arrive as strings -> coerce.
export const startCricketSchema = z.object({
  format: z.enum(["T20", "ODI"]).optional(),
  overs_per_innings: z.coerce.number().int().min(1).max(50).optional(),
});

export type RecordCricketEventInput = z.infer<typeof recordCricketEventSchema>;
export type StartCricketInput = z.infer<typeof startCricketSchema>;
